import { render, staticRenderFns } from "./ContactLunch.vue?vue&type=template&id=2a638012&scoped=true&lang=html&"
import script from "./ContactLunch.vue?vue&type=script&lang=js&"
export * from "./ContactLunch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a638012",
  null
  
)

export default component.exports